import React from 'react'
import { CFooter,CImage } from '@coreui/react'
import zyplelogo1 from './images/PAYROLL.jpg';

const AppFooter = () => {
  return (
    <CFooter>
      <div>
      <CImage  src={zyplelogo1} width={120} height={35}  />
        {/* <a href="https://zyplesoft.com" target="_blank" rel="noopener noreferrer">
          Zyple Software
        </a> */}
        {/* <span className="ms-1">&copy; 2022 creativeLabs.</span> */}
      </div>
       <div style={{width:"50%",textAlignLast:"right"}}>
       <span className="me-1">HelpDesk Email ID: <a href="#">empclaims@absindia.net</a></span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://zyplesoft.com" target="_blank" rel="noopener noreferrer">
          {/* CoreUI React Admin &amp; Dashboard Template */}
          Zyple Software.
        </a>
        <span className="ms-1">&copy; All Rights Reserved</span> 
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
